<template>
  <b-navbar :mobile-burger="false" :class="{ 'navbar_reduce': reduce }">
    <template slot="brand">
      <b-navbar-item>
        <a id="navbar-burger" :class="{ 'navbar-burger': true, 'burger': true, }"
           style="display: block"
           @click.prevent="toggleSidebar">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </b-navbar-item>
    </template>
    <template slot="end">
      <help-menu :reduce="reduce"></help-menu>
      <b-navbar-item v-if="windowWidth > 1023" tag="div">
        <account-name :classes="['has-text-right']"></account-name>
      </b-navbar-item>
      <account-menu :reduce="reduce"></account-menu>
    </template>
  </b-navbar>
</template>

<script>
import { mapMutations } from 'vuex';
import * as MUTATIONS from '@/store/mutations';
import AccountMenu from './AccountMenu.vue';
import AccountName from './AccountName.vue';
import HelpMenu from './HelpMenu.vue';

export default {
  name: 'UserNavbar',
  components: { AccountMenu, AccountName, HelpMenu },
  props: {
    reduce: {
      type: Boolean,
      default: false,
    },
    sidebarOpened: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    reduce() {
      const burger = document.getElementById('navbar-burger');
      if (burger) {
        if (!this.reduce) {
          burger.classList.add('crossed');
        } else {
          burger.classList.remove('crossed');
        }
      }
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  methods: {
    ...mapMutations({ setSidebarWidth: MUTATIONS.SET_SIDEBAR_WIDTH }),
    toggleSidebar() {
      const sidebar = document.getElementById('main-sidebar');
      if (sidebar) {
        const sidebarContent = sidebar.querySelector('div.sidebar-content');
        if (sidebarContent) {
          setTimeout(() => {
            const computedStyles = window.getComputedStyle(sidebarContent);
            const width = computedStyles.getPropertyValue('width');
            this.setSidebarWidth(Number(width.substring(0, width.length - 2)));
          }, 500); // todo refactor
        }
      }
      this.$emit('update:reduce', !this.reduce);
    },
  },
};
</script>

<style lang="stylus" scoped>
#navbar-burger
  span
    transition-duration 86ms
    transition-property top, opacity, transform
    &:nth-child(2)
      opacity 1
#navbar-burger.crossed
  span
    transition-duration 86ms
    transition-property top, opacity, transform
    &:nth-child(1)
      top calc(50% - 1px)
      transform rotate(45deg)
    &:nth-child(3)
      top calc(50% - 1px)
      transform rotate(-45deg)
    &:nth-child(2)
      opacity 0
.navbar
  position fixed
  left 0
  right 0
  padding-left 248px
  transition padding-left .3s linear
  @media screen and (max-width 1023px)
    padding-left 150px
  &_reduce
    padding-left 150px
    @media screen and (max-width 1023px)
      padding-left 120px
    @media screen and (max-width 768px)
      padding-left 0
  >>>.help-menu
    padding-right 0
</style>
